import Swiper, { Navigation} from 'swiper';

export function SwiperInit(swiperId, additionalNavParams, additionalContentParams) {
  let tabItem = $("#" + swiperId + "-navgation li");

  let swiperTab = new Swiper("#" + swiperId + "-navgation", {
    modules: [Navigation],
    
    slidesPerView: "auto",
    grabCursor: true,
    
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    ...additionalNavParams
  });

  let swiper = new Swiper("#" + swiperId + "-content", {
    autoHeight: true,
    spaceBetween: 20,
    allowTouchMove: false,
    breakpoints: {
      768: {
        allowTouchMove: true,
      },
    },
    on: {
        slideChange: function () {
        let n = this.activeIndex;
        changeTab(n);
      },
    },
    ...additionalContentParams
  });

  tabItem.click(function () {
    let idx = $(this).index();
    swiper.slideTo(idx);
  });

  function changeTab(index) {
    tabItem.removeClass("active").eq(index).addClass("active");
    if (window.innerWidth <= 767) {
      swiperTab.slideTo(index - 0);
      }else{
      swiperTab.slideTo(index - 1);
    }
  }
}